// extracted by mini-css-extract-plugin
module.exports = {"dialog__window":"Messages_dialog__window_2coR3","dialog__preview":"Messages_dialog__preview_2az9J"};